import React from 'react';
import './Spinner.css';

function Spinner({ size = 'medium', text, light = false }) {
  return (
    <div className={`spinner-container ${light ? 'spinner-light' : ''}`}>
      <div className={`spinner spinner-${size}`}>
        <div className="spinner-ring"></div>
      </div>
      {text && <p className="spinner-text">{text}</p>}
    </div>
  );
}

export default Spinner;
